import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { User, logout } from "../redux/authSlice";
import { removeUserFromLocalStorage, USER_KEY } from "../utils/jwt";
import axiosConfig from "./axiosConfig";
import store from "../redux/store";

export class RestServiceConnection {
    baseUrl: string | undefined;
    response: AxiosResponse<any> | null = null;
    apiPublicUrl: string | undefined;

    constructor() {
        this.baseUrl = process.env.REACT_APP_API_URL;
        this.response = null;
        this.apiPublicUrl = process.env.REACT_APP_API_PUBLIC_URL;
    }

    async makeRequest(config: AxiosRequestConfig, isAuth: boolean = false) {

        if (config.url !== undefined) {
            config.url = this.baseUrl + config.url;
        }

        if (config.headers === undefined) {
            config.headers = {
                'Content-Type': 'application/json',
            }
        }

        if (isAuth) {
            let storageData = localStorage.getItem(USER_KEY);
            if (storageData) {
                let user = JSON.parse(storageData) as User;
                if (user && user.token)
                    Object.assign(config.headers, {
                        'Authorization': `Bearer ${user.token}`
                    })
            }
        }

        try {
            this.response = await axiosConfig(config);
        } catch (error: any) {
            /* if (error.response?.status === 401 && (error.response?.data?.message === "Expired JWT Token")) {
                removeUserFromLocalStorage();
                store.dispatch(logout());
                window.location.reload();
            } */
            console.log(error.response?.data?.message)
        }

        return this.response;
    }

    getResponse() {
        return this.response;
    }

    getResponseData() {
        return this.response?.data;
    }

    getOnlyData() {
        return this.response?.data?.data;
    }

}